var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7461 17.3747C13.0598 17.3747 12.0958 17.1265 10.6523 16.32C8.89696 15.3356 7.53922 14.4268 5.79336 12.6855C4.11008 11.0033 3.29094 9.91417 2.1445 7.82799C0.849341 5.47253 1.07012 4.23784 1.31692 3.71014C1.61082 3.07944 2.04465 2.70221 2.6054 2.3278C2.92389 2.11912 3.26094 1.94024 3.61227 1.79342C3.64743 1.77831 3.68012 1.76389 3.7093 1.75088C3.88333 1.67249 4.147 1.55401 4.48098 1.68057C4.70387 1.76424 4.90286 1.93546 5.21434 2.24307C5.85313 2.87307 6.72606 4.27616 7.04809 4.96522C7.2643 5.42963 7.40739 5.7362 7.40774 6.08003C7.40774 6.48256 7.20524 6.79299 6.9595 7.12803C6.91344 7.19096 6.86774 7.25108 6.82344 7.30944C6.5559 7.661 6.49719 7.7626 6.53586 7.94401C6.61426 8.30858 7.19891 9.39385 8.15973 10.3526C9.12055 11.3113 10.1745 11.859 10.5405 11.9371C10.7297 11.9775 10.8334 11.9163 11.1962 11.6393C11.2482 11.5996 11.3016 11.5584 11.3575 11.5173C11.7323 11.2385 12.0283 11.0413 12.4214 11.0413H12.4235C12.7656 11.0413 13.0584 11.1896 13.5436 11.4343C14.1764 11.7535 15.6216 12.6152 16.2555 13.2547C16.5638 13.5655 16.7357 13.7638 16.8198 13.9863C16.9463 14.3214 16.8272 14.584 16.7495 14.7598C16.7364 14.7889 16.722 14.8209 16.7069 14.8564C16.5589 15.2071 16.379 15.5435 16.1694 15.8612C15.7957 16.4202 15.417 16.853 14.7849 17.1472C14.4603 17.3007 14.1051 17.3785 13.7461 17.3747Z",
    fill: "#6AD2FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonCall);
export default __webpack_public_path__ + "static/media/ion_call.79f5baeede8fe91472d7a715e86c5189.svg";
export { ForwardRef as ReactComponent };